import RouteUtils from '~/core/utils/RouteUtils';

import {quotePaths} from '~/paths';

const routes = [
	{
		path: quotePaths.quoteLandingPage,
		title: 'Get a Quote',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/QuoteLandingPage');
		}),
	},
	{
		path: quotePaths.eligibilityTestPage,
		title: 'Prequalifying Questionnaire',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PrequalifyingQuestionnairePage');
		}),
	},
	//Quick Quote
	{
		path: quotePaths.qqDetailsPage,
		title: 'Quick Quote',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/QQBusinessActivityPage');
		}),
	},
	{
		path: quotePaths.qqReviewPagePattern,
		title: 'Quick Quote - Details',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/QQReviewPage');
		}),
	},
	// Full Quote
	{
		path: quotePaths.fqBusinessPage,
		title: 'Quote - Business Details',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/BusinessDetailsPage');
		}),
	},
	{
		path: quotePaths.fqBusinessPagePattern,
		title: 'Quote Business Details',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/BusinessDetailsPage');
		}),
	},
	{
		path: quotePaths.fqWagesPage,
		title: 'Quote - Wages',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/WagesPage');
		}),
	},
	{
		path: quotePaths.fqWagesPagePattern,
		title: 'Quote Wages',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/WagesPage');
		}),
	},
	{
		path: quotePaths.fqContactPage,
		title: 'Contact - Details',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ContactDetailsPage');
		}),
	},
	{
		path: quotePaths.fqContactPagePattern,
		title: 'Add Contact Details',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ContactDetailsPage');
		}),
	},
	{
		path: quotePaths.fqPremiumPagePattern,
		title: 'Premium',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PremiumPage');
		}),
	},
	{
		path: quotePaths.fqPaymentPagePattern,
		title: 'Payment',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PaymentPage');
		}),
	},
	{
		path: quotePaths.fqConfirmationPagePattern,
		title: 'Confirmation',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ConfirmationPage');
		}),
	},
	//Save and Retrieve
	{
		path: quotePaths.saveQuotePagePattern,
		title: 'Save Quote',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/SaveQuotePage');
		}),
	},
	{
		path: quotePaths.retrieveQuotePage,
		title: 'Retrieve Quote',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/RetrieveQuotePage');
		}),
	},
];

export default routes;
